module.exports = __webpack_public_path__ + "img/suzuki-logo.2cce7d82.png";